import {React, useEffect } from 'react'
import { useNavigate  } from 'react-router-dom'

function Logout(){
    
    const navigate =  useNavigate()

    const sessionExpire = () => {
        localStorage.removeItem('brCode')
        localStorage.removeItem('userDetails')
        localStorage.removeItem('brName')
        localStorage.removeItem('auth_token')
    }

    useEffect(()=>{
        sessionExpire()
        navigate('/auth/signin')
    },[navigate])

    return(
        <div></div>
    )
    
}

export default Logout